'use client';

import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { Toast } from '@base-ui/react/toast';
// ---------------------------------------------------------------------------
// Global toast manager (works outside React tree)
// ---------------------------------------------------------------------------

export var toastManager = /*#__PURE__*/Toast.createToastManager();

// ---------------------------------------------------------------------------
// Internal helper
// ---------------------------------------------------------------------------

function normalizeV2Options(options) {
  var normalized = _objectSpread({}, options);

  // textLink → action
  if (normalized.textLink && !normalized.action) {
    normalized.action = {
      label: normalized.textLink.text,
      href: normalized.textLink.url
    };
  }

  // hideCloseButton → closeButton (inverted)
  if (normalized.hideCloseButton !== undefined && normalized.closeButton === undefined) {
    normalized.closeButton = !normalized.hideCloseButton;
  }

  // titleClassName → className
  if (normalized.titleClassName && !normalized.className) {
    normalized.className = normalized.titleClassName;
  }
  return normalized;
}
function createToast(variant, title, options) {
  var _ref = options ? normalizeV2Options(options) : {},
    description = _ref.description,
    action = _ref.action,
    _ref$closeButton = _ref.closeButton,
    closeButton = _ref$closeButton === void 0 ? true : _ref$closeButton,
    duration = _ref.duration,
    className = _ref.className;
  return toastManager.add({
    title: title,
    description: description,
    type: variant,
    timeout: duration,
    data: {
      action: action,
      closeButton: closeButton,
      className: className
    }
  });
}

// ---------------------------------------------------------------------------
// Public API
// ---------------------------------------------------------------------------

export var toast = {
  /** Show an informational toast (blue accent). */
  info: function info(title, options) {
    return createToast('info', title, options);
  },
  /** Show a success toast (green accent). */
  success: function success(title, options) {
    return createToast('success', title, options);
  },
  /** Show a warning toast (orange accent). */
  warning: function warning(title, options) {
    return createToast('warning', title, options);
  },
  /** Show an error toast (red accent). */
  error: function error(title, options) {
    return createToast('error', title, options);
  },
  /** Dismiss a specific toast by ID, or all toasts when called without arguments. */
  dismiss: function dismiss(id) {
    return toastManager.close(id);
  }
};